export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/mezzoforte-icon.svg?baf7ed6b2a8c2e326ac2f66757fe3fa1";